import {
  FullBox
} from "./chunk-C2USQR22.js";
import {
  Box_default
} from "./chunk-GDQZHQO7.js";

// packages/ui-lib/src/icons/SpinnerIcon.tsx
import React2 from "react";
import cn from "classnames";

// packages/ui-lib/src/icons/SpinnerIcon.css.ts
var size = { standard: "SpinnerIcon_standard__w71aop2", big: "SpinnerIcon_big__w71aop3" };
var spinner = "SpinnerIcon__w71aop1";

// packages/ui-lib/src/icons/SpinnerIcon.tsx
var SpinnerIcon = ({ size: size2 = "standard" }) => {
  const classNames = cn(spinner, size[size2]);
  return /* @__PURE__ */ React2.createElement(Box_default, {
    className: classNames
  });
};
var FullSizeSpinner = () => /* @__PURE__ */ React2.createElement(FullBox, {
  align: "center",
  alignY: "center"
}, /* @__PURE__ */ React2.createElement(SpinnerIcon, {
  size: "big"
}));

export {
  SpinnerIcon,
  FullSizeSpinner
};
//# sourceMappingURL=chunk-ZZAL5ZCJ.js.map
